import React from 'react';
import './loading.css';

export const MiningLoading: React.FC = () => {
  const factories = [
    {
      id: 1,
      ecsTokens: '5,000',
      gameExperience: 'Level 5',
      description: 'Basic Mining Operations'
    },
    {
      id: 2,
      ecsTokens: '10,000',
      gameExperience: 'Level 10',
      description: 'Advanced Extraction'
    },
    {
      id: 3,
      ecsTokens: '50,000',
      gameExperience: 'Level 20',
      description: 'Elite Mining Systems'
    },
    {
      id: 4,
      ecsTokens: '100,000',
      gameExperience: 'Level 30',
      description: 'Master Mining Facilities'
    }
  ];

  return (
    <div className="mining-loading-container">
      <div className="mining-loading-bg">
        <img
          src="https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/mining-factory/mining-loading-bg.webp"
          alt="Mining Factory Background"
          className="mining-bg-image"
        />
      </div>

      <div className="mining-unlock-panel">
        <h1 className="mining-panel-title">Mining Factory Unlock System</h1>

        <p className="mining-panel-description">
          There are 4 Strong Mining Factories. Factories unlock automatically based on the player's Gem balance and game experience level:
        </p>

        <div className="mining-hourglass-container">
          <img
            src="https://nsdlsrcxj85lsgpu.public.blob.vercel-storage.com/sandwatch.gif"
            alt="Loading"
            className="mining-hourglass"
          />
        </div>

        <div className="mining-factories-list">
          {factories.map((factory) => (
            <div key={factory.id} className="mining-factory-item">
              <span className="factory-ecs">{factory.ecsTokens} Gems</span>
              <span className="factory-separator"> & </span>
              <span className="factory-experience">{factory.gameExperience}</span>
              <span className="factory-arrow"> → </span>
              <span className="factory-unlock">Unlock Factory {factory.id}</span>
            </div>
          ))}
        </div>

        <div className="mining-panel-footer">
          <p className="mining-footer-text">
            Unlocking each mining factory would give you unbelievable and unexpected results!
          </p>
        </div>
      </div>
    </div>
  );
};
